import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CaretDown } from '@phosphor-icons/react';
const USAGE_TEXT = 'This presentation contains original concepts, creative strategy and execution ideas developed by Snakker™. It is shared confidentially for evaluation and discussion with Solventum and may not be reproduced, adapted, distributed or implemented without Snakker’s written agreement.';

/** Quiet, expandable usage note. Never visually dominant. */
export function ConceptUsage() {
  const [open, setOpen] = useState(false);
  return <div className="mt-4" data-id="element-135" data-mp="e44hnril22u3">
      <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} className="inline-flex items-center gap-1.5 font-body text-[11px] uppercase tracking-[0.16em] text-[rgba(1,51,43,0.4)] transition-colors hover:text-[rgba(1,51,43,0.7)] focus:outline-none focus-visible:text-background" data-id="element-136" data-mp="e3b9qn7w17ad">
        Concept usage
        <motion.span animate={{
        rotate: open ? 180 : 0
      }} transition={{
        duration: 0.25
      }} className="inline-flex" data-id="element-137" data-mp="11rujl76l5s4k">
          <CaretDown size={12} weight="bold" aria-hidden="true" data-id="element-138" data-mp="1qgukfiifuhkv" />
        </motion.span>
      </button>

      <AnimatePresence initial={false} data-id="element-139" data-mp="1cpzf2g75eim1">
        {open && <motion.p initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} transition={{
        duration: 0.3,
        ease: [0.22, 1, 0.36, 1]
      }} className="max-w-[62ch] overflow-hidden font-body text-[11px] leading-[1.7] text-[rgba(1,51,43,0.4)]" data-id="element-140" data-mp="1gruhjo0tf21e">
            <span className="mt-3 block" data-id="element-141" data-mp="ttzon9ttjn4k">{USAGE_TEXT}</span>
          </motion.p>}
      </AnimatePresence>
    </div>;
}